import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { computed } from "vue";
import { storeToRefs } from "pinia";

import { Location } from "~/js/interfaces/locations";
import { Translations } from "~/js/interfaces/translations";

import { getClasses } from "~/js/composables/classes";

import { useLocationsStore } from "~/js/store/locations";

import CardLocation from "~/vue/molecules/cards/CardLocation.vue";
import CardUnit from "~/vue/molecules/cards/CardUnit.vue";
import CardLocationSidebar from "~/vue/molecules/cards/CardLocationSidebar.vue";
import CardUnitSidebar from "~/vue/molecules/cards/CardUnitSidebar.vue";

interface Props {
	locations: Array<Location> | null;
	translations?: Translations | null;
	utilities?: string;
	isSidebar?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GridLocations',
  props: {
    locations: {},
    translations: { default: null },
    utilities: { default: "" },
    isSidebar: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const locationsStore = useLocationsStore();
const { filters } = storeToRefs(locationsStore);

const classes = computed(() => ({
	wrapper: {
		grid: "grid grid-cols-1 sm:grid-cols-2",
		spacing: props.isSidebar ? "gap-2" : "gap-6 mb-20",
		utilities: props.utilities,
	},
	unitWrapper: {
		grid: props.isSidebar
			? "grid grid-cols-1 sm:grid-cols-2 px-2 lg:px-4 sm:col-span-2 w-full ml-2 pl-4"
			: "grid grid-cols-1 sm:grid-cols-2 px-2 lg:px-4 sm:col-span-2 w-full",
		spacing: props.isSidebar ? "gap-2" : "gap-6",
		utilities: props.utilities,
	},
}));

const getVisibleUnits = (location: Location) => {
	if (!location.document?.units) return [];
	return location.document.units.filter(
		(unit) => unit.availableNow === filters.value.availableNow.value || unit.availableSoon === filters.value.availableSoon.value,
	);
};

const getSidebarUnitClasses = (index: number, total: number) => {
	if (!props.isSidebar) return "col-span-2 xl:col-auto";
	const isOddLast = total % 2 === 1 && index === total - 1;
	return isOddLast ? "col-span-2" : "col-span-1";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.locations, (location) => {
      return (_openBlock(), _createElementBlock("div", {
        key: location.document.id,
        class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
      }, [
        ((location.document.type == 'building' || location.document.type == 'project') && !__props.isSidebar)
          ? (_openBlock(), _createBlock(CardLocation, {
              key: 0,
              location: location.document,
              translations: __props.translations,
              utilities: "col-span-2",
              featured: true
            }, null, 8, ["location", "translations"]))
          : _createCommentVNode("", true),
        ((location.document.type == 'building' || location.document.type == 'project') && __props.isSidebar)
          ? (_openBlock(), _createBlock(CardLocationSidebar, {
              key: 1,
              location: location.document,
              translations: __props.translations,
              utilities: "col-span-2"
            }, null, 8, ["location", "translations"]))
          : _createCommentVNode("", true),
        (location.document?.units)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_unref(getClasses)(classes.value, 'unitWrapper'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVisibleUnits(location), (unit, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: unit.slug
                }, [
                  (!__props.isSidebar)
                    ? (_openBlock(), _createBlock(CardUnit, {
                        key: 0,
                        location: unit,
                        translations: __props.translations,
                        utilities: getSidebarUnitClasses(index, getVisibleUnits(location).length)
                      }, null, 8, ["location", "translations", "utilities"]))
                    : _createCommentVNode("", true),
                  (__props.isSidebar)
                    ? (_openBlock(), _createBlock(CardUnitSidebar, {
                        key: 1,
                        location: unit,
                        translations: __props.translations,
                        utilities: getSidebarUnitClasses(index, getVisibleUnits(location).length)
                      }, null, 8, ["location", "translations", "utilities"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})